export type FollowUp = {
  summary?: string;
  events?: {
    published: string;
    summary?: string;
    url: string;
    title?: string;
  }[];
};
const compact = (text: string) => text.replace(/\s+/g, " ").trim();

// Keep distinct evidence, but do not repeat sentences already in the overview.
function additionalDetail(text: string, overview: string) {
  const known = new Set(overview.split(/(?<=[.!?])\s+/).map(compact));
  return text
    .split(/(?<=[.!?])\s+/)
    .filter((sentence) => !known.has(compact(sentence)))
    .join(" ")
    .trim();
}

export function ResultExplanation({
  explanation,
  followUp,
}: {
  explanation: string;
  followUp?: FollowUp | null;
}) {
  const summary = followUp?.summary?.trim() || "";
  const events = followUp?.events || [];
  return (
    <>
      <p className="explanation">{explanation}</p>
      {(summary || events.length > 0) && (
        <details className="follow-up">
          <summary>후속 사건과 근거 보기</summary>
          {summary && <p>{summary}</p>}
          {events.map((event, i) => {
            const detail = additionalDetail(event.summary || "", summary);
            return (
              <p key={i}>
                <time>{event.published}</time>
                {detail && <> · {detail}</>}
                <br />
                <a href={event.url} target="_blank" rel="noreferrer">
                  {event.title || "원문 확인"}
                </a>
              </p>
            );
          })}
        </details>
      )}
    </>
  );
}
